/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { onChangeIndianCurrency } from "src/helpers/FormDetails";
import { PRODUCT_ID } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import CustomCheckBox from "src/shared/CustomCheckBox";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

type MemberData = {
  title?: string;
  gender?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  dob?: string;
  maritalStatus?: string;
  nationality?: string;
  countryOfResidence?: string;
  cityOfResidence?: string;
  dateOfLastEntry?: string;
  educationQualification?: string;
  mobileNo?: string;
  telePhoneNo?: string;
  email?: string;
  occupation?: string;
  occupationCode?: string;
  subOccupation?: string;
  nameOfOrganization?: string;
  designation?: string;
  annualIncome?: string;
  panNo?: string;
  natureOfWork?: string;
  relationship?: string;
  UIDNo?: string;
  electronicAccount?: string;
  eiaNumber?: string;
  businessOwner?: string;
};

type MemberReviewSchema = {
  [key in keyof MemberData]: {
    label: string;
    visible?: boolean;
  };
};

function JointLifeMember() {
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const memberDetailsSchema: MemberReviewSchema = mefSchema?.memberDetailsSchema || {};
  const jointLifeDetails = useAppSelector((state) => state.jointLifeAddendum);
  const productId = useAppSelector((state) => state.common.productId);
  const member = jointLifeDetails?.member || {};

  const renderField = (fieldName: keyof typeof memberDetailsSchema) => {
    const fieldConfig = memberDetailsSchema[fieldName];
    if (
      fieldName === "subOccupation" &&
      !(member.occupationCode === "OT" || member.occupation === "Others")
    ) {
      return null;
    }
    if (!fieldConfig) {
      return null;
    }

    if (
      fieldName === "designation" &&
      (["SE", "OT", ""].includes(member?.occupationCode || "") ||
        ["Self Employed", "Others", ""].includes(member?.occupation || ""))
    ) {
      return null;
    }

    if (
      fieldName === "countryOfResidence" ||
      fieldName === "cityOfResidence" ||
      fieldName === "dateOfLastEntry"
    ) {
      if (member?.nationality === "Indian") return null;
    }

    if (
      (fieldName === "UIDNo" || fieldName === "electronicAccount") &&
      productId !== PRODUCT_ID.GHS
    ) {
      return null;
    }

    if (fieldName === "businessOwner") {
      if (!["BO", "SE"].includes(member.occupationCode!)) {
        return null;
      }
      return (
        <div className="col-span-1" key={fieldName}>
          <CustomCheckBox
            label={fieldConfig.label}
            name="member.businessOwner"
            isReview
            checked={member.businessOwner}
            handleBlur={() => {}}
            setFieldValue={() => {}}
          />
        </div>
      );
    }

    if (
      fieldName === "eiaNumber" &&
      (productId !== PRODUCT_ID.GHS || member?.electronicAccount?.toLowerCase() !== "yes")
    ) {
      return null;
    }

    return (
      <div className="col-span-1" key={fieldName}>
        <CustomLabel>{fieldConfig.label}</CustomLabel>
        <CustomReviewField>
          {fieldName === "annualIncome"
            ? onChangeIndianCurrency(member[fieldName] || "-")
            : member[fieldName] || "-"}
        </CustomReviewField>
      </div>
    );
  };

  return (
    <div>
      <div className="flex justify-start mt-10">
        <p className="text-base font-bold">Details of Members to be Insured</p>
      </div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 lg:gap-x-32 md:gap-x-36 gap-x-3 mt-6 max-sm:ml-4">
        {Object.keys(memberDetailsSchema).map((field) =>
          renderField(field as keyof typeof memberDetailsSchema)
        )}
      </div>
    </div>
  );
}

export default JointLifeMember;
